import Player from '@vimeo/player';
import { Image } from 'expo-image';
import { useEffect, useRef, useState } from 'react';

import { getVimeoUrl } from './get-vimeo-url';
import { VimeoEmbedProps } from './types';

export function VimeoEmbed({ video, style }: VimeoEmbedProps) {
  const iFrameRef = useRef();
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  useEffect(() => {
    const player = new Player(iFrameRef.current);

    player.on('playing', () => {
      setIsVideoPlaying(true);
    });

    return () => player.off('playing');
  }, []);

  return (
    <>
      <iframe
        ref={iFrameRef}
        src={getVimeoUrl(video.id, { background: true })}
        allow="autoplay"
        loading="eager"
        style={{ position: 'absolute', ...style } as React.CSSProperties}
      />

      {!isVideoPlaying && (
        <Image
          source={(video.pictures.sizes ?? []).map(sizedPicture => {
            return { ...sizedPicture, uri: sizedPicture.link };
          })}
          alt=""
          style={[{ position: 'absolute' }, style]}
          contentFit="cover"
          contentPosition="center"
        />
      )}
    </>
  );
}
